module.exports = __webpack_public_path__ + "static/media/pintpharma.db5d7a79.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/pintpharma.png
// module id = 135
// module chunks = 0